import React, { useEffect, Fragment, useRef, } from 'react';
import { Button, } from 'reactstrap';
import { chunk, mapValues, orderBy, get, pick, omit, uniqBy, keyBy, } from 'lodash';
import { toast, } from 'react-toastify';
import { format as formatDate, } from 'date-fns';
import jsbarcode from 'jsbarcode';
import numeral from 'numeral';

import firebase from '../../firebase';
import { fields, statuses, boxSizes, deliveryTypes, deliveryType, getCombinedItems, } from '../../shared/models/combiningRequest';
import { idWithTenant, fieldDisplayValue, postalCodeWithHyphen, } from '../../shared/util';
import { deliveryTimes, prefectures, } from '../../shared/config';
import { newId } from '../../util';
import useQueryParams from '../hooks/useQueryParams';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import AdminPage from '../hocs/AdminPage';
import ShippingRequestFormModal from '../modals/ShippingRequestFormModal';
import ShippingRequestCsvFlowModal from '../modals/ShippingRequestCsvFlowModal';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import ExportButton from '../ExportButton';

const { entries } = Object;
const db = firebase.firestore();
const storageRef = firebase.storage().ref();
const tenantsRef = db.collection('tenants');
const combiningRequestsRef = db.collectionGroup('combiningRequests');
const statusesByLabel = mapValues(keyBy(entries(statuses), _ => _[1].label), '0');
const combiningRequestsCsvInfoRef = db.collection('settings').doc('combiningRequestsCsvInfo');
function AdminCombiningRequestList (props) {
  const { ids } = useQueryParams();
  const combiningRequests = useDocumentsFetch(ids?.map(_ => tenantsRef.doc(_.tenantId).collection('combiningRequests').doc(_.combiningRequestId)), [JSON.stringify(ids)]);

  return (
    <div className="admin-amazon-combining-request-list container-fluid bg-white">
      {
        combiningRequests.map(_ => <ListItem combiningRequest={_} />)
      }
    </div>
  );
}

function ListItem (props) {
  const { combiningRequest } = props;
  const combinedItems = getCombinedItems(combiningRequest);
  const products = useDocumentsFetch([...combiningRequest.items.map(_ => _.productId), ...combinedItems.map(_ => _.productId)].map(_ => combiningRequest.ref.parent.parent.collection('products').doc(_)), [combiningRequest]);
  const productsById = keyBy(products, 'id');
  const canvasRef = useRef(null);
  useEffect(() => {
    if(canvasRef.current != null) {
      jsbarcode(canvasRef.current, idWithTenant(combiningRequest.ref));
    }
  }, [canvasRef.current]);

  return (
    <Fragment>
      <div className="d-flex justify-content-start">
        <div className="card p-5 align-items-start">
          <div style={{ fontSize: 25 }}>
            {idWithTenant(combiningRequest.ref)}
          </div>
          <canvas ref={canvasRef} style={{ width: 'auto' }} />
          <div className="mt-4">
            <h5>加工元商品</h5>
            <div>
              {
                combiningRequest.items.map((item, i) => {
                  const { productId, quantity } = item;
                  const product = productsById[productId];

                  return product != null && (
                    <div key={i}>
                      [{idWithTenant(product.ref)}] {product.name} {numeral(quantity).format()}個
                    </div>
                  );
                })
              }
            </div>
          </div>
          <div className="mt-4">
            <h5>完成商品</h5>
            <div>
              {
                combinedItems.map((item, i) => {
                  const { productId, quantity } = item;
                  const combinedProduct = productsById[productId];

                  return combinedProduct != null && (
                    <div key={i}>
                      [{idWithTenant(combinedProduct.ref)}] {combinedProduct.name} {numeral(quantity).format()}個
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
      <div className="pagebreak" />
    </Fragment>
  );
}

AdminCombiningRequestList.forPrint = true;

export default AdminPage(AdminCombiningRequestList);
